/**
 * USB/HID product identifiers paired with HORI_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */

/**
 * Product identifier (PID) of the HORI Mini Wired Gamepad for PS4.
 * Pair with HORI_VENDOR_ID to distinguish it from Fighting Commander.
 */
export const HORI_MINI_WIRED_GAMEPAD_PRODUCT_ID = 0x00EE

/**
 * Product identifier (PID) of the supported HORI Fighting Commander entry.
 * Pair with HORI_VENDOR_ID to distinguish it from the Mini Wired Gamepad.
 */
export const HORI_FIGHTING_COMMANDER_PRODUCT_ID = 0x0084
